<template>
  <div class="wt-phone-number">
    <div class="col-3 field-label">Transfer Phone Number:</div>
    <div class="col-7 field-response" v-html="phoneNumber">
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import fetchPortalJson from '@/js/PortalFetchJson'
import PropsMixin from './FormElementPropsMixin'

export default {
  name: 'WarmTransferPhoneNumber',
  props: ['campaignId', 'externalPhoneNumber'],
  mixins: [PropsMixin],
  data () {
    return {
      phoneForCampus: null,
      phoneForProgram: null,
      internalPhoneNumber: null
    }
  },
  methods: {
    async getPhone () {
      if (this.externalPhoneNumber) {
        return
      }
      if ((this.currentCampus || this.currentProgram) && this.currentCampus === this.phoneForCampus && this.currentProgram === this.phoneForProgram) {
        return
      }
      this.internalPhoneNumber = (await fetchPortalJson(`warm_transfer_phones?campaign_id=${this.campaignId}${this.currentCampus ? '&campus_id=' + this.currentCampus : ''}${this.currentProgram ? '&program_id=' + this.currentProgram : ''}`)).warm_transfer_phone.phone
      this.phoneForProgram = this.currentProgram
      this.phoneForCampus = this.currentCampus
    }
  },
  computed: {
    phoneNumber () {
      return this.externalPhoneNumber ? this.externalPhoneNumber : this.internalPhoneNumber
    }
  },
  mounted () {
    this.getPhone()
  },
  watch: {
    currentProgram (newValue) {
      this.getPhone()
    }
  }
}
</script>
